export const builder = {
  // Physics prompt dialog
  "builder.physics.title.adjust.flight.time": "Ajustar Tiempo de Vuelo",
  "builder.physics.title.adjust.height": "Ajustar Altura",
  "builder.physics.title.fix": "Corregir Vuelo del Pase",
  "builder.physics.button.adjust.time": "Ajustar Tiempo",
  "builder.physics.button.adjust.height": "Ajustar Altura",
  "builder.physics.button.fix": "Corregir",
  "builder.physics.height.changed.description":
    "Cambiar la altura a {{ height }} ({{ meters }}m) requiere un tiempo de vuelo de {{ requiredTime }}s. El tiempo de vuelo actual es {{ currentTime }}s.",
  "builder.physics.height.changed.note":
    "El tiempo de llegada del balón se ajustará para coincidir con la nueva altura.",
  "builder.physics.time.changed.description":
    "El tiempo de vuelo actual de {{ currentTime }}s requiere una altura de {{ height }} ({{ meters }}m).",
  "builder.physics.time.changed.note":
    "La altura se ajustará de {{ fromHeight }} a {{ toHeight }}.",
  "builder.physics.fix.description":
    "El vuelo de este pase es inválido. La altura de {{ height }} ({{ meters }}m) requiere un tiempo de vuelo de {{ requiredTime }}s (actual es {{ currentTime }}s.)",
  "builder.physics.fix.option.time":
    "Ajustar Tiempo: Cambiar tiempo de vuelo de {{ currentTime }}s a {{ time }}s (manteniendo la altura en {{ height }}).",
  "builder.physics.fix.option.height":
    "Ajustar Altura: Cambiar altura de {{ currentHeight }} ({{ currentMeters }}m) a {{ height }} ({{ meters }}m) (manteniendo el tiempo de vuelo actual).",

  // Warning list
  "builder.warnings.title": "Advertencias",
  "builder.physics.warning.message":
    "Pase de {{ name }} a {{ time }}s: altura {{ height }} requiere {{ requiredTime }}s de vuelo, el actual es {{ actualTime }}s",
  "builder.warning.player.speed":
    "{{ name }} (equipo {{ team }}) excede el límite de velocidad por {{ excess }}m/s a {{ time }}s",
  "builder.warning.pass.speed":
    "Pase de {{ kicker }} a {{ receiver }} viaja a {{ speed }} m/s a {{ time }}s",
  "builder.warning.kick.speed":
    "Disparo de {{ kicker }} viaja a {{ speed }} m/s a {{ time }}s",
  "builder.warning.pass.extreme.height":
    "El pase de {{ name }} a {{ time }}s tiene una altura extrema de {{ height }}m",
  "builder.warning.pass.extreme.time":
    "El pase de {{ name }} a {{ time }}s tiene un tiempo de vuelo extremo de {{ flightTime }}s",

  // Builder toolbar
  "builder.selected": "Seleccionado:",
  "builder.selected.none": "Ninguno",
  "builder.time": "Tiempo:",
  "builder.recovery.title": "¿Recuperar escenario sin guardar?",
  "builder.recovery.message": "Se encontró un borrador local de recuperación de {{ savedAt }} para este escenario. Restáuralo para recuperar el trabajo sin guardar, o descártalo para mantener la versión cargada.",
  "builder.recovery.restore": "Restaurar borrador",
  "builder.recovery.discard": "Descartar borrador",

  // Builder menu
  "builder.menu.save": "Guardar",
  "builder.menu.save.as": "Guardar Como",
  "builder.menu.play.test": "Probar",
  "builder.menu.import.file": "Importar Archivo",
  "builder.menu.export.file": "Exportar Archivo",
  "builder.menu.exit": "Salir del Editor",
  "builder.menu.settings": "Configuración",
  "builder.menu.view.rotation": "Rotación de Vista:",
  "builder.menu.play.speed": "Velocidad de Reproducción:",
  "builder.menu.play.resolution": "Resolución de Reproducción:",
  "builder.menu.player.speed.limit": "Límite de Velocidad del Jugador:",
  "builder.menu.ball.speed.limit": "Límite de Velocidad del Balón:",
  "builder.menu.show.waypoints": "Mostrar Puntos de Ruta",
  "builder.menu.show.actions": "Mostrar Acciones",
  "builder.menu.show.ball.path": "Mostrar Trayectoria del Balón",
  "builder.menu.show.jersey.numbers": "Mostrar Números de Camiseta",
  "builder.menu.route.fade.distance": "Distancia de Desvanecimiento de Ruta:",
  "builder.menu.untitled": "Sin Título",
  "builder.menu.exit.confirm.title": "¿Estás seguro?",
  "builder.menu.exit.confirm.message": "Tienes cambios sin guardar. ¿Estás seguro de que quieres salir?",
  "builder.menu.save.success.title": "Escenario guardado",
  "builder.menu.save.success.message": "Los cambios de tu escenario se han guardado.",
  "builder.menu.save.error.title": "Error al guardar el escenario",
  "builder.menu.save.error.message": "No se pudieron guardar los cambios de tu escenario.",

  // Decision overlay
  "builder.decision.toggle.show": "Mostrar puntuaciones",
  "builder.decision.toggle.hide": "Ocultar puntuaciones",
  "builder.decision.auto.timeline.score": "Autoasignar puntuaciones",
  "builder.decision.option": "Opción #{{ index }}",
  "builder.decision.metric.completion": "Precisión",
  "builder.decision.metric.threat": "Peligro",
  "builder.decision.metric.goal.chance": "Prob. de gol",
  "builder.decision.metric.turnover": "Pérdida",
  "builder.decision.autoassign.error.noScenario": "No hay un escenario válido disponible para la puntuación automática de la línea de tiempo.",
  "builder.decision.autoassign.error.noUserPlayer": "Añade un jugador controlado por el usuario antes de ejecutar la puntuación automática de la línea de tiempo.",
  "builder.decision.autoassign.error.noTimelineData": "El motor de decisiones no devolvió datos de línea de tiempo utilizables.",
  "builder.decision.autoassign.error.noScoreWindows": "No se devolvieron ventanas de puntuación de línea de tiempo utilizables, así que no se aplicaron acciones de puntuación.",
  "builder.decision.autoassign.error.generic": "La puntuación automática de la línea de tiempo falló. Inténtalo de nuevo.",
  "builder.decision.autoassign.success":
    "Se aplicaron {{ created }} ventanas de puntuación en {{ players }} jugadores.{{ replacedText }}{{ defaultedText }}",
  "builder.decision.autoassign.success.replaced": " Se reemplazaron {{ count }} acciones de puntuación existentes.",
  "builder.decision.autoassign.success.defaulted": " Se dejó en 0: {{ players }}{{ more }}.",
  "builder.decision.autoassign.success.defaulted.more": " +{{ count }} más",

  // Action menu
  "builder.action.deselect": "Deseleccionar",
  "builder.action.delete": "Eliminar",
  "builder.action.set.height": "Establecer Altura",
  "builder.action.set.score": "Establecer Puntuación",
  "builder.action.set.time": "Establecer Tiempo",
  "builder.action.more": "Más",

  // Player menu
  "builder.player.take.ball": "Tomar Balón",
  "builder.player.pass.ball": "Pasar Balón",
  "builder.player.shoot.ball": "Disparar Balón",
  "builder.player.set.player": "Establecer Jugador",
  "builder.player.look": "Mirar",
  "builder.player.face": "Orientar",
  "builder.player.face.forward": "Mirar al frente",
  "builder.player.face.target": "Mirar al objetivo",
  "builder.player.signal": "Señal",
  "builder.player.score": "Puntuación",
  "builder.player.set.position": "Establecer Posición",
  "builder.player.set.as": "Establecer como {{ initials }}",

  // Field menu
  "builder.field.flip.teams": "Invertir Equipos",
  "builder.field.add.opponent": "Agregar Oponente",
  "builder.field.add.team.mate": "Agregar Compañero",
  "builder.field.opponent": "Oponente {{ initials }}",
  "builder.field.team.mate": "Compañero {{ initials }}",
  "builder.field.close": "Cerrar",

  // Waypoint menu
  "builder.waypoint.insert.after": "Insertar Después",
  "builder.waypoint.insert.before": "Insertar Antes",
};
